// src/pages/Services.jsx
import React, { useState, useEffect } from 'react'; // Import useState and useEffect for the slideshow
import servicesBg from '../assets/images/companyImg.JPG'; // Import your background image for services

// Import placeholder images for the slideshow
import serviceSlide1 from '../assets/images/formwork04.JPG'; // Replace with your actual service image 1
import serviceSlide2 from '../assets/images/onsite.jpg'; // Replace with your actual service image 2
import serviceSlide3 from '../assets/images/bg-team.jpg'; // Replace with your actual service image 3
import serviceSlide4 from '../assets/images/formwork06.JPG';
import serviceSlide5 from '../assets/images/formwork00.JPG';
import serviceSlide6 from '../assets/images/formwork01.JPG';
import serviceSlide7 from '../assets/images/formwork02.JPG';
import serviceSlide8 from '../assets/images/formwork03.JPG';
import serviceSlide9 from '../assets/images/formwork04.JPG';
import serviceSlide10 from '../assets/images/formwork05.JPG';


function Services() {
  // Array of images for the slideshow
  const slideshowImages = [
    { src: serviceSlide1, alt: "Civil Engineering Project" },
    { src: serviceSlide2, alt: "Building Construction Site" },
    { src: serviceSlide3, alt: "Maintenance Work" },
    { src: serviceSlide4, alt: "Maintenance Work" },
    { src: serviceSlide5, alt: "formwork"},
    { src: serviceSlide6, alt: "formwork"},
    { src: serviceSlide7, alt: "formwork"},
    { src: serviceSlide8, alt: "formwork"},
    { src: serviceSlide9, alt: "formwork"},
    { src: serviceSlide10, alt: "formwork"},

  ];

  // State to manage the current active slide index
  const [currentSlide, setCurrentSlide] = useState(0);

  // Effect for automatic slideshow (optional, can be removed if manual navigation is preferred)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) =>
        prevSlide === slideshowImages.length - 1 ? 0 : prevSlide + 1
      );
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval); // Clean up the interval on component unmount
  }, [slideshowImages.length]); // Re-run effect if number of images changes

  // Function to go to the previous slide
  const prevSlide = () => {
    setCurrentSlide((prevSlide) =>
      prevSlide === 0 ? slideshowImages.length - 1 : prevSlide - 1
    );
  };

  // Function to go to the next slide
  const nextSlide = () => {
    setCurrentSlide((prevSlide) =>
      prevSlide === slideshowImages.length - 1 ? 0 : prevSlide + 1
    );
  };

  return (
    // Outermost div: Acts as the container for the entire page and its background
    <div className="position-relative overflow-hidden">
      {/* Background Image Layer: Positioned absolutely to cover the entire outermost div */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          backgroundImage: `url(${servicesBg})`, // Use the imported background image
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed', // Makes the background image static (parallax effect)
          opacity: 0.3, // Corrected opacity to a valid range (0-1) for better visibility
          zIndex: 0, // Ensures it's behind the content
        }}
      ></div>

      {/* Main Content Wrapper: All visible page content goes here, positioned above the background */}
      <div className="container py-3 position-relative z-1 text-dark"> {/* Adjusted py-5, kept text-white for main text */}
        <h1 className="mb-4 text-center display-4 fw-bold">Our Services</h1>
        <p className="lead text-center mb-5">
          At LIYO & SONS GROUP (PTY) Ltd, we offer a comprehensive range of professional services tailored to meet diverse client needs.
          Our goal is to deliver high-quality solutions in construction, engineering, maintenance, and Quantity Surveying Services — backed by expertise and
          a commitment to ensure cost efficiency, contractual compliance, and successful project delivery.
        </p>

        {/* Comprehensive Services Section */}
        <section className="py-3 mb-5 position-relative z-1 "> {/* Added bg-white, z-1, and text-dark */}
          <h3 className="mb-4 text-center">Comprehensive Solutions for Your Projects</h3>
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                {/* Tender Documentation and Procurement */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-light text-dark text-center">
                      <i className="bi bi-book display-5 text-warning mb-3"></i> {/* Icon */}
                      <h5 className="card-title">Tender Documentation and Procurement</h5>
                      <p className="card-text">
                      Preparation of Bills of Quantities (BoQ) and tender documents.Advising on procurement strategies and contract selection.
                      Evaluation of tenders and recommendations for award.
                      </p>
                    </div>
                  </div>
                </div>
                 {/* Civil Engineering */}
                 <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-light text-dark text-center">
                      <i className="bi bi-hammer display-5 text-warning mb-3"></i> {/* Icon */}
                      <h5 className="card-title">Civil Engineering</h5>
                      <p className="card-text">
                        We specialize in the development of urban and rural roads, stormwater drainage, and earthworks. Our experienced team
                        ensures the structural integrity and efficiency of all infrastructure projects.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Cost Planning and Estimation */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-light text-dark text-center">
                      <i className="bi bi-wallet display-5 text-warning mb-3"></i> {/* Icon */}
                      <h5 className="card-title">Cost Planning and Estimation</h5>
                      <p className="card-text">
                        Preparation of detailed cost estimates at all project stages.Development of cost plans to monitor and control budgets.
                        Benchmarking and feasibility studies for accurate financial forecasting.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Contract Administration */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-light text-dark text-center">
                      <i className="bi bi-briefcase display-5 text-warning mb-3"></i> {/* Icon */}
                      <h5 className="card-title">Contract Administration</h5>
                      <p className="card-text">
                        Drafting and reviewing contractual agreements. Managing variations, claims, and contractual disputes.
                        Ensuring compliance with contractual obligations throughout the project lifecycle.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Cost Control and Financial Management */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-light text-dark text-center">
                      <i className="bi bi-card-checklist display-5 text-warning mb-3"></i> {/* Icon */}
                      <h5 className="card-title">Cost Control and Financial Management</h5>
                      <p className="card-text">
                        Monitoring project costs against budgets.Preparing interim valuations and payment certificates.
                        Forecasting final accounts and managing cash flow.
                      </p>
                    </div>
                  </div>
                </div>
                 {/*  Final Account Preparation */}
                 <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-light text-dark text-center">
                      <i className="bi bi-clipboard-data display-5 text-warning mb-3"></i> {/* Icon */}
                      <h5 className="card-title"> Final Account Preparation</h5>
                      <p className="card-text">
                      Negotiating and agreeing on final accounts with contractors.Preparing detailed financial reports for project close-out.
                      </p>
                    </div>
                  </div>
                </div>
                 {/* Risk and Value Management */}
                 <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-light text-dark text-center">
                      <i className="bi bi-file-earmark-richtext display-5 text-warning mb-3"></i> {/* Icon */}
                      <h5 className="card-title">Risk and Value Management</h5>
                      <p className="card-text">
                        Identifying cost-related risks and mitigation strategies.Conducting value engineering workshops to optimize project value.
                        Advising on lifecycle costing for long-term asset management.
                      </p>
                    </div>
                  </div>
                </div>
                {/* General Building Construction */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-light text-dark text-center">
                      <i className="bi bi-building display-5 text-warning mb-3"></i> {/* Icon */}
                      <h5 className="card-title">General Building Construction</h5>
                      <p className="card-text">
                        From residential to commercial structures, we provide complete building solutions — from planning to execution —
                        meeting all industry standards and client expectations.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Maintenance */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-light text-dark text-center">
                      <i className="bi bi-tools display-5 text-warning mb-3"></i> {/* Icon */}
                      <h5 className="card-title">Maintenance</h5>
                      <p className="card-text">
                        Our preventive and corrective maintenance services ensure the ongoing functionality and appearance of built environments,
                        including plumbing, electrical, and general facility upkeep.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Landscaping */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-light text-dark text-center">
                      <i className="bi bi-tree display-5 text-warning mb-3"></i> {/* Icon */}
                      <h5 className="card-title">Landscaping</h5>
                      <p className="card-text">
                        We design and implement beautiful and functional outdoor spaces that enhance both aesthetics and environmental value.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Fencing & Security */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-light text-dark text-center">
                      <i className="bi bi-shield-lock display-5 text-warning mb-3"></i> {/* Icon */}
                      <h5 className="card-title">Fencing & Security</h5>
                      <p className="card-text">
                        We provide fencing solutions for residential, commercial, and agricultural applications — including electric fencing,
                        security extensions, and perimeter monitoring systems.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Renovations & Alterations */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-light text-dark text-center">
                      <i className="bi bi-house-gear display-5 text-warning mb-3"></i> {/* Icon */}
                      <h5 className="card-title">Renovations & Alterations</h5>
                      <p className="card-text">
                        Our renovations team specializes in transforming existing structures with upgrades, alterations, and functional improvements
                        that align with your vision and budget.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Plant and Equipment Supply */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-light text-dark text-center">
                      <i className="bi bi-truck display-5 text-warning mb-3"></i> {/* Icon */}
                      <h5 className="card-title">Plant and Equipment Supply</h5>
                      <p className="card-text">
                        We supply high-performance construction equipment to support projects of all scales, ensuring reliability and efficiency
                        in every operation.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Sourcing of Construction Labour */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-light text-dark text-center">
                      <i className="bi bi-person-gear display-5 text-warning mb-3"></i> {/* Icon */}
                      <h5 className="card-title">Sourcing of Construction Labour</h5>
                      <p className="card-text">
                        We assist clients in acquiring skilled labour for civil and building construction, ensuring work quality and compliance
                        with safety standards.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Consulting Services */}
                <div className="col">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body bg-light text-dark text-center">
                      <i className="bi bi-chat-dots display-5 text-warning mb-3"></i> {/* Changed text-primary to text-warning */}
                      <h5 className="card-title">Consulting and Additional Services</h5>
                      <p className="card-text">
                        Our industry experts provide clients with valuable advice, planning assistance, project management insights, Cost audits, financial due diligence and
                        cost-effective construction strategies for optimal results.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Service Image Slideshow */}
        <section className="my-2 py-3 text-center position-relative z-1"> {/* Adjusted py-5, added text-dark */}
          <h3 className="mb-4">Visuals of Our Services</h3>
          <p className="lead mb-4">Explore some of our recent work and capabilities.</p>

          <div id="serviceCarousel" className="carousel slide carousel-fade rounded shadow-lg overflow-hidden" data-bs-ride="carousel">
            <div className="carousel-indicators">
              {slideshowImages.map((_, idx) => (
                <button
                  key={idx}
                  type="button"
                  data-bs-target="#serviceCarousel"
                  data-bs-slide-to={idx}
                  className={idx === currentSlide ? 'active' : ''}
                  aria-current={idx === currentSlide ? 'true' : 'false'}
                  aria-label={`Slide ${idx + 1}`}
                  onClick={() => setCurrentSlide(idx)} // Manual navigation
                ></button>
              ))}
            </div>
            <div className="carousel-inner" style={{ height: '320px' }}> {/* Fixed height for carousel */}
              {slideshowImages.map((image, idx) => (
                <div
                  key={idx}
                  className={`carousel-item h-100 ${idx === currentSlide ? 'active' : ''}`}
                >
                  <img
                    src={image.src}
                    className="d-block w-100 h-100 object-fit-cover"
                    alt={image.alt}
                  />
                  {/* Optional: Add carousel caption */}
                  <div className="carousel-caption d-none text-warning d-md-block">
                    <h5>{image.alt}</h5>
                    <p>Brief description of the service shown.</p>
                  </div>
                </div>
              ))}
            </div>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#serviceCarousel"
              data-bs-slide="prev"
              onClick={prevSlide} // Manual navigation
            >
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#serviceCarousel"
              data-bs-slide="next"
              onClick={nextSlide} // Manual navigation
            >
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </section>
      </div> {/* End of main content wrapper */}
    </div> // End of outermost div
  );
}

export default Services;
